import { render } from "./ItemAvaliacao.vue?vue&type=template&id=4fe25e8c"
import script from "./ItemAvaliacao.vue?vue&type=script&lang=js"
export * from "./ItemAvaliacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__